import { useState } from "react";

import { InterimStates } from "../InterimStates";

import { Dropdown, Message } from 'semantic-ui-react'

interface IProps {
    tags: any,
    refetchParent: any,
    loading: any,
    error: any,
    data: any,
    updateTags: any,
    payload: any,
}

const TagsPicker = ({
    tags,
    refetchParent,
    loading,
    error,
    data,
    updateTags,
    payload,
}: IProps) => {
    // The dropdown's value is server state, so a failed save leaves it showing the old tags.
    // Without this the rejection was unhandled, the refetch never ran, and the selection just
    // snapped back — indistinguishable from "nothing happened". A server-side crash on this
    // mutation went unreported in production for exactly that reason.
    const [saveError, setSaveError] = useState<string | null>(null);
    const [saving, setSaving] = useState(false);

    if (loading || error) {
        return <InterimStates loading={loading} error={error} label='tags' />
    }

    const handleChange = async (_: any, data: any) => {
        setSaveError(null);
        setSaving(true);
        try {
            await updateTags({
                variables: {
                    ...payload,
                    tagIds: data.value
                }
            });

            await refetchParent();
        } catch (e: any) {
            setSaveError(e?.message || 'Could not save tags. Please try again.');
        } finally {
            setSaving(false);
        }
    };

    const tagOptions = data.tags.map((p: any) => ({
        key: p.id,
        text: p.name,
        value: p.id,
    }));

    return (
        <>
            <Dropdown
                placeholder='Tags'
                fluid
                multiple
                value={(tags || []).map((p: any) => p.id)}
                onChange={handleChange}
                search
                selection
                loading={saving}
                disabled={saving}
                options={tagOptions}
            />
            {saveError && (
                <Message negative size='tiny' style={{ marginTop: '0.5em' }}>
                    <Message.Header>Tags not saved</Message.Header>
                    <p>{saveError}</p>
                </Message>
            )}
        </>
    )
}

export { TagsPicker }
